import { logNonExistingComponentState } from '../../../utils/log-utils';
import { Badge } from '../../dataDisplay';
/**
 * @private For internal use only
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private For internal use only.
 */
export var _NotSupportedBadge = _ref => {
  var {
    details
  } = _ref;
  logNonExistingComponentState(details);
  return /*#__PURE__*/_jsx(Badge, {
    "data-testid": "not-supported-badge-".concat(details.componentName),
    type: "secondary",
    status: "critical",
    label: "Not supported"
  });
};
_NotSupportedBadge.displayName = '_NotSupportedBadge';
//# sourceMappingURL=_NotSupportedBadge.js.map